<template>
    <div class="h-screen bg-[#23242A]">
        <div class="flex lg:flex-row flex-col px-4 pt-4 bg-[#23242A] text-white">
            <div class="transition-all duration-100 ease-linear" :class="(add || edit)?'lg:w-[50%] w-full':'w-full'">
                <div ref="productList" class="rounded-[10px] bg-[#2B2C32] w-full min-h-[630px] overflow-x-auto overflow-hidden">
                    <div class="text-[24px] text-white px-4 pt-4">
                        <div class="flex w-full" :class="resized?'':'justify-between'">
                            <span class="font-semibold min-w-[250px]">Master Product List</span>
                            <div class="flex flex-row gap-2">
                                <input type="text" v-model="search" @keydown="searchData" class="rounded h-[40px] bg-field-black align-top border-0" placeholder="Search..." />
                                <div class="input-wrapper">
                                    <div class="relative">
                                        <select v-model="complianceProvider" @change="searchData" class="capitalize block rounded border-none bg-field-black w-full text-sm tracking-wider text-white h-[40px]">
                                            <option value="">Select One</option>
                                            <option v-for="(eachComplianceProvider, ind) in complianceProviders" :key="'plant-'+ind" :value="eachComplianceProvider">{{eachComplianceProvider}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div :class="countCheck?(resized?'bg-white text-theme-green w-full':'bg-white text-theme-green'):'bg-theme-borderblack text-theme-modalbg min-w-[40px]'" class="font-[20px] flex justify-center align-center rounded px-2 h-[40px]">
                                    {{countCheck}}
                                </div>
                                <div class="relative" tabIndex="0" @blur="closeDropDown">
                                    <div @click="toggleDropDown"  class="text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer">
                                        <span>
                                            <svg fill="currentColor" width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
                                            </svg>
                                        </span>
                                    </div>
                                    <div v-if="toggleAddDropDown" class="absolute top-14 right-0 w-60   mt-1  z-10 rounded-md shadow-lg">
                                        <div class="absolute right-0 -top-4 right-4 h-0 w-0 border-x-8 border-x-transparent border-b-[16px] border-b-gray-black"></div>
                                        <ul role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-item-3" class="bg-gray-black max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                            <li @click="openPurchaseOrderUpload" id="listbox-item-1" role="option" class="cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9">
                                                <div class="flex items-center">
                                                    <span class="ml-3 block text-white font-normal truncate uppercase">
                                                        OCS upload
                                                    </span>
                                                </div>
                                            </li>
                                            <li @click="openImportProductUpload" id="listbox-item-1" role="option" class="cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9">
                                                <div class="flex items-center">
                                                    <span class="ml-3 block text-white font-normal truncate uppercase">
                                                        Alberta order form upload 
                                                    </span>
                                                </div>
                                            </li>
                                            <li @click="openManitobaImportUpload" id="listbox-item-1" role="option" class="cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9">
                                                <div class="flex items-center">
                                                    <span class="ml-3 block text-white font-normal truncate uppercase">
                                                        Mbll upload 
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <button
                                    @click="importProducts"
                                    class="flex flex-row items-center disabled:bg-field-black disabled:text-theme-modalbg text-white bg-theme-green rounded h-10 px-4 uppercase"
                                >
                                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M9,10V16H15V10H19L12,3L5,10H9M12,5.8L14.2,8H13V14H11V8H9.8L12,5.8M19,18H5V20H19V18Z" class="fill-white" />
                                    </svg>
                                    <span class="text-sm">Import</span>
                                </button>
                                <button
                                    :disabled="!canExport"
                                    @click="exportProducts"
                                    class="flex flex-row items-center disabled:bg-field-black disabled:text-theme-modalbg text-white bg-theme-green rounded h-10 px-4 uppercase"
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM19 20V18H5V20H19Z" :class="canExport ? 'fill-white' : 'fill-gray-700'"/>
                                    </svg>
                                    <span class="text-sm">Export</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="table w-full mt-6 px-2 pb-4">
                        <new-table-lite
                            :is-slot-mode="true"
                            :has-checkbox="true"
                            :cross-page-select-all="true"
                            :selected-rows="selectedRows"
                            :select-all-records="selectAllRecords"
                            :is-loading="table.loading"
                            :class="'block w-full min-h-[480px] admin-table admin-table-custom'"
                            :rowClasses="row => row?'id-'+row.id:null"
                            :columns="table.columns"
                            :rows="table.rows"
                            :total="table.totalRecords"
                            :sortable="table.sortable"
                            :page-size="table.pagesize"
                            @do-search="searchProduct"
                            :page="table.page"
                            @row-clicked="selectedRow"
                            @return-checked-rows="onCheckedRows"
                            @update:selectAllRecords="selectAllRecords = $event"
                            :pageOptions='table.pageOptions'
                            :messages="{
                                pagingInfo: 'Total: {2}',
                                pageSizeChangeLabel: 'Items per Page',
                                gotoPageLabel: 'Go to page',
                                noDataAvailable: 'No records found!',
                            }"
                        >
                            <template v-slot:thc_cbd="data">
                                <div v-if="data.value.thcCbdValueType=='range'">
                                    <p><span class="text-white">THC:</span> {{ data.value.thcMin }} - {{ data.value.thcMax }}{{data.value.concentration_unit}}</p>
                                    <p><span class="text-white">CBD:</span> {{ data.value.cbdMin }} - {{ data.value.cbdMax }}{{data.value.concentration_unit}}</p>
                                </div>
                                <div v-else>
                                    <p><span class="text-white">THC:</span> {{ data.value.thc }}{{data.value.concentration_unit}}</p>
                                    <p><span class="text-white">CBD:</span> {{ data.value.cbd }}{{data.value.concentration_unit}}</p>
                                </div>
                            </template> 
                        </new-table-lite>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Env from '@/env';
import { useSnackbar } from "vue3-snackbar"
import {mapGetters, mapMutations} from 'vuex'
import debounce from 'lodash/debounce'
import { defineComponent, reactive, ref} from "vue";
import BusinessProduct from '@/controllers/BusinessProductApis'
import NewTableLite from '@/components/table/masterProductTableLite.vue'
import Helpers from '@/helpers'
export default defineComponent({
    props: ['resized'],
    components: {
        NewTableLite
    },
    setup(){
        let search = ref('')
        const snackbar = useSnackbar();
        const complianceProvider = ref('')
        const toggleAddDropDown = ref(false)
        const toggleImport = ref(false)
        const openImportProduct = ref(false)
        const openManitobaImport = ref(false)
        const selectedRows = ref([])
        const selectAllRecords = ref(false)
        const table = reactive({
            loading: false,
            columns: [
                {label: 'Id', field: 'id', sortable:false, isKey:true, columnClasses:'hidden', headerClasses:'hidden' },
                {label: 'Name', field:'name', sortable: true},
                {label: 'GTIN', field:'gtin', sortable: true},
                {label: 'Size', field:'size', sortable: true},
                {label: 'Weight Equivalency', field:'weight_equivalent_dry_cannabis', sortable: true},
                {label: 'Compliance Provider', field:'complianceProvider', sortable: false},
                {label: 'SKU', field: 'sku', sortable: true},
                {label: 'THC/CBD', field:'thc_cbd', sortable: true},
                {label: 'Compliance Type', field:'complianceType', sortable: true},
                // {label: 'Product form', field:'product_form', sortable: false},
            ],
            rows: [],
            totalRecords: 0,
            page: 1,
            sortable: {
                order: "",
                sort: "",
            },
            pagesize: Env.defaultPageSize,
            pageOptions: Env.pageList,
            count: 0
        })
        const countCheck = ref(null)
        const complianceProviders = ['ocs', 'aglc', 'mbll']

        return {snackbar, toggleAddDropDown, toggleImport, openImportProduct, openManitobaImport, search, countCheck, complianceProvider, table, complianceProviders, selectedRows, selectAllRecords}
    },
    mounted(){
        this.searchProduct(0, Env.defaultPageSize, this.table.sortable.sort, this.table.sortable.order)
        this.emitter.on("reloadProductList", this.reloadProductList);
    },
    beforeDestroy() {
        this.emitter.off("reloadProductList", this.reloadProductList);
    },
    computed: {
        ...mapGetters({
            vg_selectedLocation: 'location/selected'
        }),
        canExport() {
            return this.selectAllRecords || this.selectedRows.length > 0
        },
    },
    methods: {
        toggleDropDown(){
            this.toggleAddDropDown = !this.toggleAddDropDown
        },
        closeDropDown(){
            this.toggleAddDropDown = false
        },
        openPurchaseOrderUpload(){
            this.toggleAddDropDown = false
            this.$emit('togglePurchaseOrderUploadPop', true)
        },
        toggleImportProduct(){
            this.openImportProduct = !this.openImportProduct
        },
        closeImportProduct(){
            this.openImportProduct = false
        },
        openImportProductUpload(){
            this.openImportProduct = false
            this.$emit('toggleProductImportPop', true)
        },
        openManitobaImportUpload(){
            this.toggleAddDropDown = false
            this.$emit('toggleManitobaImportPop', true)
        },
        importProducts(){
            this.$emit('toggleMasterProductImportPop', true)
        },
        async searchProduct(offset=0, limit=10, sort, order){
            let page = (offset/limit)+1
            this.table.page = page
            this.table.pagesize=limit
            this.table.loading = true
            let params = `page=${this.table.page}&perPage=${this.table.pagesize}`
            params += sort?`&sort=${sort}&order=${order}`:''
            params += this.search?`&search=${this.search.replace(/[^0-9a-z'àâçéèêëîïôûùüÿñ:;()/\."-_\s]/gi, '')}`:''
            params += this.complianceProvider?`&complianceProvider=${this.complianceProvider}`:''
            let {data: {payload}} = await BusinessProduct.fetchAllMasterProduct(params)
            this.table.rows = payload.products
            this.table.totalRecords = payload.totalRecords;
            this.table.sortable.order = order
            this.table.sortable.sort = sort
            this.table.loading = false
        },
        async reloadProductList(editItem){
            this.searchProduct()
        },
        searchData: debounce(function(){
            if(this.search.length>=3 || this.search==''){
                this.clearCheckboxSelection()
                this.searchProduct(0, Env.defaultPageSize, this.table.sortable.sort, this.table.sortable.order)
            }
        }, 400),
        onCheckedRows(ids){
            this.selectedRows = [...ids]
            this.countCheck = this.selectAllRecords ? this.table.totalRecords : this.selectedRows.length
        },
        clearCheckboxSelection(){
            this.selectedRows = []
            this.selectAllRecords = false
        },
        async exportProducts(){
            let payload = this.selectAllRecords
                ? { allProducts: 'true', productIds: [] }
                : {
                    allProducts: 'false',
                    productIds: this.selectedRows.map((id) => parseInt(id)),
                }
            if(this.search){
                payload.search = this.search
            }
            if(this.complianceProvider){
                payload.complianceProvider = this.complianceProvider
            }
            this.vm_spinner(true)
            let res = await BusinessProduct.exportMasterProducts(payload)
            if(res.status==201){
                const url = window.URL.createObjectURL(res.data);
                const link = document.createElement('a');
                const filename = res.headers['x-suggested-filename'] || 'Template-Export-Product-Columns.xlsx';
                link.href = url;
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
            this.snackbar.add({
                type: 'info',
                text: res.status===201?'The Master product is exported.':Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            this.vm_spinner(false)
        },
        selectedRow(item){
            // selection effect
             let activeRow = document.getElementsByClassName('id-'+item.id);
             if(activeRow[0] && activeRow[0].parentNode && activeRow[0].parentNode.children){
                for(let sibling of activeRow[0].parentNode.children){
                    sibling.classList.remove('active-row')
                }
             }
             activeRow[0].classList.add("active-row")

            // action
            this.$emit('toggleAddEdit', {add: false, edit: true, editItem: item})
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>